export enum ApplicationStates {
  DEFAULT,
  SUCCESS,
  ERROR,
  WARNING,
  INACTIVE,
  CANCEL
}
